<script setup lang="ts">
import { useAuthStore } from "@/stores/auth";

const authStore = useAuthStore();
</script>

<template>
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <router-link
        class="nav-link"
        active-class="active"
        to="/adm/broadcast-messages"
        >Enviadas</router-link
      >
    </li>
    <!-- <li class="nav-item">
      <router-link class="nav-link" active-class="active" to="/#">Rascunhos</router-link>
    </li> -->
    <li class="nav-item">
      <router-link
        class="nav-link"
        active-class="active"
        to="/adm/new-broadcast-message"
        >Nova Mensagem</router-link
      >
    </li>
  </ul>
  <div class="nav-tabbed-content">
    <slot />
  </div>
</template>

<style scoped>
.nav-tabs {
  border-color: var(--dark-grey);
}

.nav-item {
  margin-right: 5px;
}

.nav-link {
  padding: 2px 12px;
  color: var(--white-ice);
}

.nav-link:hover {
  border-color: var(--dark-grey);
  border-bottom-color: var(--dark-color);
  color: var(--primary-color);
}

.nav-link:focus {
  border-color: var(--dark-grey);
  border-bottom-color: var(--dark-color);
}

.nav-link:focus-visible {
  border-radius: 4px;
  background-color: var(--dark-color);
  border: 1px solid var(--white-ice);
}

.nav-link.active {
  color: var(--primary-color);
  background-color: var(--dark-color);
  border-color: var(--dark-grey);
  border-bottom-color: var(--dark-color);
}

.nav-tabbed-content {
  padding: 10px 13px 20px;
}

@media (max-width: 767.98px) {
  .nav-tabs {
    flex-direction: row;
  }

  @media (max-width: 575.98px) {
    .nav-item {
      margin-right: 2px;
    }

    .nav-link {
      padding: 0px 6px;
    }
  }
}
</style>
